import type { Role } from '../../types/framework'
import { buildRole } from '../../utils/framework'
import { ceo } from './ceo'
import { cfo } from './cfo'
import { cio } from './cio'
import { cmo } from './cmo'
import { coo } from './coo'
import { cro } from './cro'
import {
  auditChair,
  boardChair,
  ined,
  ned,
  nfpDirector,
  nominationsChair,
} from './board'

/** All roles in the client framework, in workbook order. */
export const ROLES: Role[] = [
  ceo,
  cfo,
  cio,
  cmo,
  coo,
  cro,
  boardChair,
  ned,
  ined,
  auditChair,
  nominationsChair,
  nfpDirector,
].map(buildRole)

export function getRole(id: string): Role | undefined {
  return ROLES.find((r) => r.id === id)
}
